module.exports = __webpack_public_path__ + "img/usa-flag.5cf8aa0d.svg";